// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"c155fc04","144":"0287c199","157":"fbdd7765","261":"da5f5209","323":"225ae33c","453":"db4543df","740":"ccbd6baf","888":"cdebe5eb","899":"2bc945a8","930":"54dd4dd1"}[chunkId] + ".chunk.js";
};